import styled from 'styled-components';
import { MdAddCircleOutline } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { MdArrowDownward, MdArrowUpward, MdClose } from 'react-icons/md';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
`;

const ListArea = styled.div`
  width: 100%;
`;

const ListItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  & + & {
    margin-top: 6px;
  }
`;
const AddButtonArea = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 6px;

  font-size: 16px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  cursor: pointer;
`;

const ButtonWrapper = styled.div`
  width: fit-content;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const InputWrapper = styled.div`
  width: 100%;
  height: fit-content;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 4px 5px 0px;
  box-sizing: border-box;
`;

const InsertInput = styled.input`
  flex: 1;
  height: 44px;
  border-radius: 4px;
  padding: 5px;
  border: solid 1px #c4c4c4;
  font-size: 16px;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
`;

export default function OptionList({ option }) {
  const { formOptions, setFormOptions, optKey } = option;
  const BUTTON_SIZE = 26;
  const MAX_LIST_COUNT = 5;
  const { t } = useTranslation();

  const changeListValue = (e, key) => {
    const changed = formOptions.map((li) => {
      if (li.key === key) {
        return { ...li, value: e.target.value };
      } else {
        return li;
      }
    });
    setFormOptions(changed);
  };

  const addItem = () => {
    optKey.current = optKey.current + 1;
    setFormOptions([...formOptions, { key: optKey.current, value: '' }]);
  };

  const upItem = (itemKey) => {
    const index = formOptions.findIndex((li) => li.key === itemKey);
    const item = formOptions.find((li) => li.key === itemKey);
    if (index > 0) {
      optKey.current = optKey.current + 1;
      const updated = formOptions.filter((li) => li.key !== itemKey);
      updated.splice(index - 1, 0, item);
      setFormOptions(updated);
    }
  };

  const downItem = (itemKey) => {
    const index = formOptions.findIndex((li) => li.key === itemKey);
    const item = formOptions.find((li) => li.key === itemKey);
    if (formOptions.length - 1 > index) {
      optKey.current = optKey.current + 1;
      const updated = formOptions.filter((li) => li.key !== itemKey);
      updated.splice(index + 1, 0, item);
      setFormOptions(updated);
    }
  };

  const deleteItem = (key) => {
    const updated = formOptions.filter((li) => li.key !== key);
    setFormOptions(updated);
  };

  const Buttons = [
    {
      getComponent: (key) => {
        return <MdArrowDownward size={BUTTON_SIZE} onClick={() => downItem(key)}></MdArrowDownward>;
      }
    },
    {
      getComponent: (key) => {
        return <MdArrowUpward size={BUTTON_SIZE} onClick={() => upItem(key)}></MdArrowUpward>;
      }
    },
    {
      getComponent: (key) => {
        return <MdClose size={BUTTON_SIZE} onClick={() => deleteItem(key)}></MdClose>;
      }
    }
  ];

  return (
    <Wrapper>
      <ListArea>
        {formOptions.map((li) => (
          <ListItem key={li.key}>
            <InputWrapper>
              <InsertInput type="text" onChange={(e) => changeListValue(e, li.key)} />
            </InputWrapper>
            {Buttons.map((button) => (
              <ButtonWrapper>{button.getComponent(li.key)}</ButtonWrapper>
            ))}
          </ListItem>
        ))}
      </ListArea>
      {formOptions && formOptions.length < MAX_LIST_COUNT && (
        <AddButtonArea onClick={addItem}>
          <MdAddCircleOutline size={24}></MdAddCircleOutline>
          {t('Common.Add')}
        </AddButtonArea>
      )}
    </Wrapper>
  );
}
